import { createApiSlice } from 'app/createApiSlice'
import {
  API_GROUP_LIST,
  API_GROUP_LIST_LOT_ID,
  API_INVENTORY_LOT_ID_CHECK,
} from 'utils/apiList'

export const groupListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'groupList/api',
  endpoints(builder) {
    return {
      createGroup: builder.mutation({
        query({ name }) {
          return {
            url: API_GROUP_LIST,
            method: 'POST',
            body: {
              name,
            },
          }
        },
      }),
      fetchInventoryGroupLotId: builder.query({
        query({ groupId }) {
          return {
            url: `${API_GROUP_LIST_LOT_ID}/${groupId}`,
            method: 'GET',
          }
        },
      }),
      checkInventorysLotId: builder.mutation({
        query({ inventoryIds }) {
          return {
            url: `${API_INVENTORY_LOT_ID_CHECK}`,
            method: 'POST',
            body: {
              inventoryIds: inventoryIds,
            },
          }
        },
      }),
    }
  },
})

export const {
  useCreateGroupMutation,
  useFetchInventoryGroupLotIdQuery,
  useCheckInventorysLotIdMutation,
} = groupListApiSlice
